/* istanbul ignore file */
import React from 'react';
import styled from 'styled-components';
import { Divider } from '@material-ui/core';

export const WrapperLayout = styled(({ height, ...otherProps }) => (
  /* istanbul ignore next */
  <div {...otherProps} />
))`
  height: ${/* istanbul ignore next */ (props: any) => props.height};
  background-color: #a9a9a9;
  border-radius: 8px;
`;
export const ColoredDivider = styled(Divider)`
  && {
    background-color: #979797;
    opacity: 24%;
  }
`;
